export default __webpack_public_path__ + "static/media/category-69.7b05ec3f.svg";